module.exports = __webpack_public_path__ + "static/media/stephouse-white.8b397695.webp";